import { lt } from '@mews/framework';
import { WithAccountId } from '@mews-commander/types';
import { PaymentPlanDetailResult } from '@mews-commander/data-access';
import { Stack, Typography } from '@optimus-web/core';
import { ModalSidePanel } from '../../../../../components';
import { useGetPaymentPlanDetail } from '../../tables/PaymentPlans/queries';
import { isPaymentPlanCancellable } from '../../tables/PaymentPlans/utils';
import { WithPaymentPlanId } from '../../tables/PaymentPlans/types';
import { PaymentPlanDetailsOverviewTable } from '../../tables/PaymentPlanPaymentsOverview/PaymentPlanDetailsOverviewTable';
import { PaymentPlanDetailsCancelPlan } from '../../views/PaymentPlanDetails/PaymentPlanDetailsCancelPlanSection';
import { PaymentPlanDetailsCardSection } from './PaymentPlanDetailsCardSection';
import { PaymentPlanDetailsDetailSection } from './PaymentPlanDetailsDetailSection';

export const PaymentPlanDetailsSidePanelContent = ({
    detail,
    paymentPlanId,
    accountId,
}: { detail: PaymentPlanDetailResult } & WithPaymentPlanId & WithAccountId) => (
    <Stack vertical spacing="500">
        <PaymentPlanDetailsCardSection detail={detail} />
        <Stack vertical spacing="200">
            <Typography textStyle="titleMediumStrong" as="div">
                {lt('PaymentPlanDetailPlural')}
            </Typography>
            <PaymentPlanDetailsDetailSection detail={detail} />
        </Stack>
        <PaymentPlanDetailsOverviewTable paymentPlanId={paymentPlanId} accountId={accountId} />
    </Stack>
);

interface PaymentPlanDetailsSidePanelProps extends WithAccountId, WithPaymentPlanId {
    opened: boolean;
    onClose: () => void;
}

export const PaymentPlanDetailsSidePanel = ({
    opened,
    onClose,
    paymentPlanId,
    accountId,
}: PaymentPlanDetailsSidePanelProps & WithAccountId) => {
    const { data, isFetching } = useGetPaymentPlanDetail({ id: paymentPlanId });
    const isCancellable = isPaymentPlanCancellable(data?.status);
    return (
        <ModalSidePanel
            loading={isFetching}
            title={data?.name}
            headerActions={null}
            onClose={onClose}
            opened={opened}
            width="large"
            content={
                data ? (
                    <PaymentPlanDetailsSidePanelContent
                        detail={data}
                        accountId={accountId}
                        paymentPlanId={paymentPlanId}
                    />
                ) : null
            }
            actions={
                isCancellable ? (
                    <Stack alignment="end">
                        <PaymentPlanDetailsCancelPlan
                            paymentPlanId={paymentPlanId}
                            accountId={accountId}
                            paymentMethodData={data?.paymentMethodData}
                        />
                    </Stack>
                ) : null
            }
        />
    );
};
